/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {post, get} from "./request.helper";
import api from './api.services';
import {getLocalStorage,setSessionStorage} from '../_helpers/localStorage.helper';
import {push} from "react-router-redux";
import UserPermissionSingleton from '../_helpers/UserPermissionSingleton';
import {USER_ROLE} from '../constants/APP_CONSTANTS';
import {LSA_PREMISSIONS, SALES_REP_PERMISSIONS, PROJECT_SPECIALIST_PERMISSIONS} from '../constants/permissionsConstants';

export const userLogin = (payload) => dispatch => {
    //const adminSession = JSON.parse(getLocalStorage('__amplify__bsa-session'));
    const adminSession = JSON.parse('{"data":{"userId":"0ac600a9-535a-1d05-8153-5ad9a0350047"}}');
    const redirectURL = window.location.pathname.replace('/digitaladmin','').replace('digital-book','redirect').replace('book-details','');
    const failureRedirectUrl = window.location.origin;
    post(api.login, {token: payload, userId:adminSession.data.userId})
        .then(function (){
            get(api.profile).then(profile => {
                if (profile && profile.userRoles) {
                    const allowedRoles = ['Content Admin', 'Project Specialist', 'Sales Rep', 'LSA'];
                    let isValidUser = false;
                    profile.userRoles.forEach(role => {
                        if (allowedRoles.includes(role)) {
                            isValidUser = true;
                        }
                    });
                    UserPermissionSingleton.permissions = profile.permissions && profile.permissions.length > 0 ? profile.permissions : [];
                    if(profile.userRoles.includes(USER_ROLE.LSA)) {
                        UserPermissionSingleton.permissions.push(...LSA_PREMISSIONS);
                    } else if (profile.userRoles.includes(USER_ROLE.salesRepresentative)) {
                        UserPermissionSingleton.permissions.push(...SALES_REP_PERMISSIONS);
                    } else if (profile.userRoles.includes(USER_ROLE.ProjectSpecialist)) {
                        UserPermissionSingleton.permissions.push(...PROJECT_SPECIALIST_PERMISSIONS);
                    }
                    if(profile.userRoles.includes('LSA')){
                        setSessionStorage ('isLSAUser', 'true');
                    }
                    else{
                        setSessionStorage ('isLSAUser', 'false');
                    }
                    if(profile.userRoles.includes('Sales Rep')){
                        setSessionStorage ('isSalesRepUser', 'true');
                    }
                    else{
                        setSessionStorage ('isSalesRepUser', 'false');
                    }
                    if (isValidUser) {
                        dispatch(push(redirectURL));
                    } else {
                        window.location.replace(failureRedirectUrl);
                    }
                }
            });
        })
        .catch(function (error) {
            if (process.env.NODE_ENV !== "development") {
                if (error.status === 401) {
                    window.location.replace(failureRedirectUrl);
                }
            }
        });
};

export const refreshSession = (payload) => dispatch => {
    post(api.renew_session, {token: payload});
};



// WEBPACK FOOTER //
// ./src/_thunks/login.thunk.js